import { Box, Container, Skeleton, Stack } from '@mui/material';

/**
 * Header-and-content skeleton used while a detail page's query is loading.
 * Mirrors the layout of PageShell/DetailPageShell (avatar, title, subtitle,
 * tabs strip, content card) so the page doesn't pop in.
 */
const DetailPageSkeleton = () => (
  <Box sx={{ backgroundColor: 'background.default', minHeight: '100%', py: 5 }}>
    <Container maxWidth={false}>
      <Skeleton variant="text" width={220} height={16} sx={{ mb: 1.5 }} />
      <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 4 }}>
        <Skeleton variant="rounded" width={44} height={44} />
        <Box>
          <Skeleton variant="text" width={280} height={32} />
          <Skeleton variant="text" width={360} height={18} sx={{ mt: 0.5 }} />
        </Box>
      </Stack>
      <Stack direction="row" spacing={3} sx={{ borderBottom: 1, borderColor: 'divider', pb: 1, mb: 3 }}>
        {[140, 110, 130, 120, 90].map((w, i) => (
          <Skeleton key={i} variant="text" width={w} height={28} />
        ))}
      </Stack>
      <Stack spacing={2}>
        {[...Array(5)].map((_, i) => (
          <Skeleton key={i} variant="rounded" height={48} animation="wave" />
        ))}
      </Stack>
    </Container>
  </Box>
);

export default DetailPageSkeleton;
